<template>
  <div v-if="dataPermission.includes('CNPS_SUR_STAFF_DETAIL')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb" style="margin-left: -1rem">
            <li class="breadcrumb-item">
              <a @click="$router.push('/staff')" href="javascript:void(0)">Nhân viên</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ dataStaff.name }}</li>
          </ol>
        </nav>
      </h1>
      <button
        class="f12 float-right font-medium btn btn-outline-secondary"
        @click="$router.push('/staff')"
      >
        <i class="bx bx-arrow-back"></i> Quay lại
      </button>
    </div>
    <div class="card p-0 b-t-1-869fb229">
      <div class="card-body p-10 b-t-1-869fb229">
        <div class="form-row">
          <div class="col-md-8 my-2">
            <span class="de-img">
              <img v-if="dataStaff.avatarUrl !== ''" :src="dataStaff.avatarUrl" alt="img" />
              <img v-else src="@/assets/img/user.svg" alt="img" />
            </span>
            <div class="de-info">
              <h3 class="de-name">{{ dataStaff.name }}</h3>
              <span class="badge badge-pill badge-success">{{
                dataStaff.companyPhase | mapTextStatus(dataOptionComphase)
              }}</span>
            </div>

            <div class="clearfix"></div>
            <b-tabs style="margin-left: 1rem; margin-top: 0.5rem" content-class="mt-3" lazy>
              <b-tab title="Thông tin chung">
                <form class="mb-4">
                  <h1 class="f16 pb-1">
                    <b>Thông tin liên hệ</b>
                  </h1>
                  <div class="form-group row mb-0" v-if="dataStaff.dateOfBirth">
                    <label class="col-sm-3 col-form-label f14">Ngày sinh</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.dateOfBirth | formatDate }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.gender">
                    <label class="col-sm-3 col-form-label f14">Giới tính</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.gender | mapTextStatus(dataConfigGender) }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.userName">
                    <label class="col-sm-3 col-form-label f14">Email</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.userName }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.mobile">
                    <label class="col-sm-3 col-form-label f14">Số điện thoại</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.mobile }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.identifyCard">
                    <label class="col-sm-3 col-form-label f14">Số CMND/CCCD/HC</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.identifyCard }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.timeRange">
                    <label class="col-sm-3 col-form-label f14">Ngày cấp</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.timeRange | formatDate }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.place">
                    <label class="col-sm-3 col-form-label f14">Nơi cấp</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.place }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.address">
                    <label class="col-sm-3 col-form-label f14">Địa chỉ</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.address }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.levelEmployee">
                    <label class="col-sm-3 col-form-label f14">Cấp bậc nhân viên</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.levelEmployee }}
                      </span>
                    </div>
                  </div>
                </form>

                <form class="mb-4">
                  <h1 class="f16 pb-1">
                    <b>Vị trí</b>
                  </h1>
                  <div class="form-group row mb-0" v-if="dataStaff.companyCode">
                    <label class="col-sm-3 col-form-label f14">Mã nhân viên</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.companyCode }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.companyPhase">
                    <label class="col-sm-3 col-form-label f14">Vị trí</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.companyPhase | mapTextStatus(dataOptionComphase) }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.typeSale">
                    <label class="col-sm-3 col-form-label f14">Vai trò</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.typeSale | transfromData(dataListRole) }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.superiorName">
                    <label class="col-sm-3 col-form-label f14">Quản lý</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.superiorName }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.companyDayIn">
                    <label class="col-sm-3 col-form-label f14">Ngày vào công ty</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.companyDayIn | formatDate }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.officialTime">
                    <label class="col-sm-3 col-form-label f14">Ngày lên chính thức</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.officialTime | formatDate }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.signContractTime">
                    <label class="col-sm-3 col-form-label f14">Ngày kí HĐLĐ</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.signContractTime | formatDate }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.contractPeriod">
                    <label class="col-sm-3 col-form-label f14">Thời gian HĐ</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.contractPeriod }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.regionName">
                    <label class="col-sm-3 col-form-label f14">Vùng kinh doanh</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.regionName }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.regionMain">
                    <label class="col-sm-3 col-form-label f14">Vùng kinh doanh chính</label>
                    <div class="col-sm-9 bdl-1">
                      <span v-if="dataRegion.length" class="form-control-plaintext f14">
                        {{ filterLocal(dataStaff.regionMain, dataRegion) }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.provinceName">
                    <label class="col-sm-3 col-form-label f14">Tỉnh/Thành phố</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.provinceName }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.provinceMain">
                    <label class="col-sm-3 col-form-label f14">Tỉnh/Thành phố chính</label>
                    <div class="col-sm-9 bdl-1">
                      <span v-if="dataProvince.length" class="form-control-plaintext f14">
                        {{ filterLocal(dataStaff.provinceMain, dataProvince) }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0">
                    <label class="col-sm-3 col-form-label f14">Tracking</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        <b-form-checkbox
                          v-model="dataStaff.isTracking"
                          name="check-button"
                          switch
                          size="lg"
                          disabled
                        >
                        </b-form-checkbox>
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0">
                    <label class="col-sm-3 col-form-label f14">Chấm công</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        <b-form-checkbox
                          v-model="dataStaff.isTimeKeep"
                          name="check-button"
                          switch
                          size="lg"
                          disabled
                        >
                        </b-form-checkbox>
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.levelEmployee">
                    <label class="col-sm-3 col-form-label f14">Cấp bậc nhân viên</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.levelEmployee }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.levelEmployee">
                    <label class="col-sm-3 col-form-label f14">Số ngày nghỉ phép còn lại</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.leaveDay }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row mb-0" v-if="dataStaff.resignDate">
                    <label class="col-sm-3 col-form-label f14">Ngày nghỉ việc</label>
                    <div class="col-sm-9 bdl-1">
                      <span class="form-control-plaintext f14">
                        {{ dataStaff.resignDate | formatDate }}
                      </span>
                    </div>
                  </div>
                </form>
              </b-tab>

              <b-tab title="Tiêu chí KPI">
                <div class="mb-4 mt-3">
                  <div class="table-responsive">
                    <table class="table table-hover table-bordered">
                      <thead class="thead-light">
                        <tr class="text-center">
                          <th scope="col">Thời gian</th>
                          <th scope="col">
                            Leads /
                            <span v-if="dataUserKPI.length > 0">{{ dataUserKPI[0].leadUnit }}</span>
                            <span v-else>Ngày</span>
                          </th>
                          <th scope="col">
                            Công việc /
                            <span v-if="dataUserKPI.length > 0">{{ dataUserKPI[0].workUnit }}</span>
                            <span v-else>Ngày</span>
                          </th>
                          <th scope="col">
                            KPI /
                            <span v-if="dataUserKPI.length > 0">{{ dataUserKPI[0].kpiUnit }}</span>
                            <span v-else>Tháng</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="table-row text-center"
                          v-for="(item, index) in dataUserKPI"
                          :key="index"
                        >
                          <td>
                            <span v-if="item.dateCreate">{{
                              item.dateCreate | formatDate('HH:mm DD/MM/YYYY')
                            }}</span>
                          </td>
                          <td>
                            {{ item.lead ? item.lead : '' }}
                          </td>
                          <td>
                            {{ item.work ? item.work : '' }}
                          </td>
                          <td>
                            {{ item.kpi ? item.kpi : '' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-tab>

              <b-tab
                title="Ảnh"
                v-if="dataStaff.certificateImages && dataStaff.certificateImages.length > 0"
              >
                <div class="mb-4 mt-3">
                  <div class="form-group img-list">
                    <ul class="m-0" v-viewer>
                      <li v-for="(item, index) in dataStaff.certificateImages" :key="index">
                        <a href="javascript:void(0)">
                          <img :src="item" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Config from '../../thirdParty/config'
  import { StaffService } from '@/services/staff.service'
  import { CommonService } from '@/services/common.service'
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        validate: false,
        dataStaff: {},
        dataConfigGender: Config.configGender,
        dataOptionComphase: Config.optionComphase,
        dataConfigRegion: [],
        dataListRole: [],
        userId: '',
        dataUserKPI: [],
        dataRegion: [],
        dataProvince: [],
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    created() {
      this.fetchData()
      this.getTypeSale()
      this.getUserKPIList()
      this.getRegion()
    },

    methods: {
      async fetchData() {
        try {
          this.userId = this.$route.query.id
          const response = await StaffService.getStaffById({
            userId: this.userId,
          })
          if (response.success) {
            this.dataStaff = {
              ...response.data,
              avatarUrl: response.data.avatarUrl ? response.data.avatarUrl : '',
            }
            this.queryProvince(this.dataStaff.region)
          }
        } catch (error) {
          console.log(error)
        }
      },

      async getUserKPIList() {
        try {
          const response = await StaffService.getUserKPIList({
            userId: this.userId,
          })
          if (response.code === 1000) {
            this.dataUserKPI = response.data
          }
        } catch (error) {
          console.log(error)
        }
      },

      async getTypeSale() {
        try {
          const data = await CommonService.getTypeSale({})
          if (data.data.length > 0) {
            this.dataListRole = data.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },

      filterLocal(id, arr = []) {
        const findedData = arr.find(e => e.id === id)
        if (findedData) return findedData.text
        return ''
      },

      async getRegion() {
        try {
          const data = await StaffService.getRegions()
          if (data.data.length > 0) {
            this.dataRegion = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },

      async queryProvince(e) {
        try {
          const data = await StaffService.getProvinceRegion({
            regionId: e,
          })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
          } else {
            this.dataProvince = []
          }
        } catch (error) {}
      },
    },
  }
</script>

<style scoped></style>
